import log from "loglevel"
import { create } from "zustand"
import { API } from "../api/API"
import { useAppErrorStore } from "./AppErrorStore"

interface MasterLogStoreState {
    downloadMasterLog: () => Promise<void>
    downloading: boolean
}

export const useMasterLogStore = create<MasterLogStoreState>((set) => ({
    downloading: false,
    downloadMasterLog: async () => {
        set({ downloading: true })
        try {
            await API.downloadFile("/master-log")
        } catch (error) {
            log.error(error)
            useAppErrorStore.getState().setAppError(error.message)
        }
        set({ downloading: false })
    },
}))
